export { default as containerTemplate } from './container.dot';
export { default as playIconTemplate } from './playIcon.dot';
export { default as pauseIconTemplate } from './pauseIcon.dot';
export { default as forwardIconTemplate } from './forwardIcon.dot';
export { default as rewindIconTemplate } from './rewindIcon.dot';
export {
  default as increaseVolumeIconTemplate,
} from './increaseVolumeIcon.dot';
export {
  default as decreaseVolumeIconTemplate,
} from './decreaseVolumeIcon.dot';
export { default as muteIconTemplate } from './muteIcon.dot';



// WEBPACK FOOTER //
// ./default-modules/ui/interaction-indicator/templates/index.ts